import { AnnotationThread } from '../../autogenerated/ZoomBridge';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
export default class WavePlayerComment {
  static FILENAME = 'WAVEPLAYERDRAWING';

  constructor(comment: AnnotationThread) {
    //this.uniqueID = comment._threadId;
    const attachment: AnnotationAttachment = AnnotationUtil.getAttachmentFromThread(comment, 0);
    if (attachment != undefined && attachment != null) {
      const data: string = attachment.getData();
      if (_.isString(data)) {
        const json = JSON.parse(data);
        Object.assign(this, json);
      }
    }
    this.uniqueID = comment._threadId;
  }

  /**
   * Destructures the object into the expected format
   * of the waveplayer library:
   *
   *   uniqueID, xPos, yPos, lat, lon, vrView, time, color, isDot, isDrawing, drawingBase64
   */
  toArray() {
    return [
      this.uniqueID,
      this.xPos,
      this.yPos,
      this.lat,
      this.lon,
      this.vrView,
      this.time,
      this.color,
      this.isDot,
      this.isDrawing,
      this.drawingBase64
    ];
  }
}
